import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { FormattedMessage } from 'react-intl';

export default class PaymentDetails extends React.Component {
    static propTypes = {
        subStatus: PropTypes.string,
        status: PropTypes.string.isRequired,
        paymentDetails: PropTypes.shape({
          cashOnDeliveryAmount: PropTypes.number,
          amountPaidByCredits: PropTypes.number,
          amountPaidByCash: PropTypes.number,
          amountPaidByGopayCoins: PropTypes.number,
          amountToBePaidByRecipient: PropTypes.number,
        }),
    }

    renderRow(title, value, options = {}) {
        const { subtitle, className = '', showBottomBorder = false, showTopBorder = false, isDotted = false } = options;

        const rowClass = `
          row ${className}
          ${showBottomBorder ? (isDotted ? 'dotted-border-bottom' : 'solid-border-bottom') : ''}
          ${showTopBorder ? 'solid-border-top' : ''}
          `.trim();
        
        return (
            <div className={rowClass}>
                <div className="cell title-cell">
                    <div className="title">{title} </div>
                    {subtitle && <div className="subtitle">{subtitle}</div>}                
                </div>
                <div className="cell value-cell">{value}</div>
                </div>
        );
    }

    render() {
        const { subStatus, status, paymentDetails } = this.props;
        const {
            cashOnDeliveryAmount = 0,
            amountPaidByCredits = 0,
            amountPaidByCash = 0,
            amountPaidByGopayCoins = 0,
            amountPaidByCard = 0,
            amountToBePaidByRecipient = 0,
        } = paymentDetails || {};
        const isStatusPickedUp = status => (status === "picked-up")
        const isStatusOnHold = status => (status === "on-hold")
        const isGoSendReturnBooking = (status, subStatus) => (isStatusPickedUp(status) && isStatusOnHold(subStatus))   

        const rows = [];

        if (cashOnDeliveryAmount > 0 ) {
            rows.push(this.renderRow(
                <FormattedMessage id= "GoSend.COD.PaymentDetails.codItemPrice" defaultMessage="COD Item Price" />,
                `Rp${cashOnDeliveryAmount.toLocaleString('id-ID')}`,
                {
                    subtitle: !isGoSendReturnBooking(status, subStatus) ? <span className="subtitle">
                        <FormattedMessage id="GoSend.COD.PaymentDetails.paidByDriver" />
                        </span>: null,
                    showBottomBorder: isGoSendReturnBooking(status, subStatus) ? false : true,
                }
            ));
        }

        if (isGoSendReturnBooking(status, subStatus)) {
            rows.push(this.renderRow(
              <FormattedMessage
                id="GoSend.COD.PaymentDetails.senderPayBackToDriver"
                defaultMessage="Sender pays back to driver"
              />,
              <span className="paid-by-recipient-value">{`Rp${amountToBePaidByRecipient.toLocaleString('id-ID')}`}</span>,
              {
                showTopBorder: true,
                className: 'paid-by-recipient-value',
              }
          ))
        } else {
            if (amountPaidByCredits > 0) {
                rows.push(this.renderRow(
                    <FormattedMessage id="GoSend.COD.PaymentDetails.deliveryFeeGoPay" defaultMessage="Delivery fee (GoPay)" />,
                    `Rp${amountPaidByCredits.toLocaleString('id-ID')}`,
                    {
                        showBottomBorder: amountPaidByGopayCoins > 0,
                        isDotted: true
                    }
                ));
            } 
        
            if (amountPaidByCash > 0) {
                rows.push(this.renderRow(
                    <FormattedMessage id="GoSend.COD.PaymentDetails.deliveryFeeCash" defaultMessage="Delivery fee (Cash)" />,
                    `Rp${amountPaidByCash.toLocaleString('id-ID')}`,
                    {
                        showBottomBorder: amountPaidByGopayCoins > 0,
                        isDotted: true
                    }
                ));
            }

            if (amountPaidByCard > 0) {
                rows.push(this.renderRow(
                    <FormattedMessage id="GoSend.COD.PaymentDetails.deliveryFeeCard" defaultMessage="Delivery fee (Card)" />,
                    `Rp${amountPaidByCard.toLocaleString('id-ID')}`,
                    {
                        showBottomBorder: amountPaidByGopayCoins > 0,
                        isDotted: true
                    }
                ));
            }

            if (amountPaidByGopayCoins > 0) {
                rows.push(this.renderRow(
                    <FormattedMessage id="GoSend.COD.PaymentDetails.gopayCoins" defaultMessage="GoPay Coins applied" />,
                    `${amountPaidByGopayCoins.toLocaleString('id-ID')}`,
                ));
            }
            
            rows.push(this.renderRow(
              <FormattedMessage
              id="GoSend.COD.PaymentDetails.paidByRecipient"
              defaultMessage="Paid by recipient"
              />,
              <span className="paid-by-recipient-value">{`Rp${amountToBePaidByRecipient.toLocaleString('id-ID')}`}</span>,
            {
              showTopBorder: true,
              className: 'paid-by-recipient-value',
            }
           ));
        }
        
        return (
        <div className="payment-breakdown-container">
            <div className="table-title">
                <FormattedMessage id="GoSend.paymentDetailsTitle" defaultMessage="Payment Details" />
            </div>
            <div className="payment-breakdown-wrapper">
                <div className="payment-breakdown-table">
                    {rows}
                </div>
            </div>
        </div>
        );
    }
} 